/*
  Marks every <img> with `data-loaded="true"` (and adds `img-loaded` class)
  the moment the image finishes downloading. CSS uses this flag together
  with the `:has()` selector to clear the stub background color on the
  container, so transparent PNGs don't keep bleeding the stub through
  after they've loaded.

  Works for:
    - Images already loaded before this script runs (`img.complete`)
    - Images that finish loading later (`load` event)
    - Images added to the DOM after page load (MutationObserver)
*/
(function () {
  function markLoaded(img) {
    if (img.dataset.loaded === 'true') return;
    img.dataset.loaded = 'true';
    img.classList.add('img-loaded');
  }

  function watch(img) {
    // Real image with pixels
    if (img.complete && img.naturalHeight !== 0) {
      markLoaded(img);
      return;
    }
    img.addEventListener('load', function () { markLoaded(img); }, { once: true });
    // `error` also clears the stub — a broken image shouldn't keep a
    // colored rectangle behind it forever.
    img.addEventListener('error', function () { markLoaded(img); }, { once: true });
  }

  function init() {
    document.querySelectorAll('img').forEach(watch);

    // Handle images added dynamically after initial render (carousels
    // that clone slides, lazy-injected sections, etc.)
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') watch(node);
          else if (node.querySelectorAll) {
            node.querySelectorAll('img').forEach(watch);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
